import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-play',
    imports: [],
    templateUrl: './modal-play.component.html',
    styleUrl: './modal-play.component.scss'
})
export class ModalPlayComponent {
  // Hides the poster once playback actually starts, so it stays visible while
  // the video buffers or if autoplay is blocked.
  playing = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      videoUrl: string;
      poster?: { webp: string; jpg: string };
    }
  ) {}
}
